// Gift Box Cart Functionality
document.addEventListener('DOMContentLoaded', function() {
    initializeGiftBox();
});

async function initializeGiftBox() {
    const GIFT_BOX_VARIANT_ID = '45756434972921';
    
    // Get the dynamic price
    const giftBoxPrice = await getGiftBoxPrice();
    
    // Create the checkbox HTML with dynamic price
    const checkboxHtml = `
        <label style="display:inline; float:none" for="giftBoxCheckbox" id="giftbox">
            <input style="padding: 0 0 0 0 !important; -webkit-appearance: checkbox; float:none; vertical-align: middle; width: 15px !important;" 
                   type="checkbox" 
                   id="giftBoxCheckbox" 
                   name="giftBoxCheckbox" 
                   onchange="handleGiftBoxChange(event);">
            <strong>Gift box my order (${giftBoxPrice})</strong>
            <p><img
                    src="https://cdn.shopify.com/s/files/1/0021/4961/3625/files/Gift_wrapping_website_2.png?v=1746152046" 
                    alt="Gift Box"></p>
        </label>
    `;
    
    // Find the cart form and checkout button
    const cartForm = document.getElementById('cart_form');
    const checkoutButton = document.getElementById('checkout');
    
    if (cartForm && checkoutButton) {
        // Insert the checkbox before the checkout button
        checkoutButton.insertAdjacentHTML('beforebegin', checkboxHtml);
        
        // Check initial state
        checkInitialGiftBoxState();
        
        // Set up cart monitoring
        monitorCartChanges();
    }
}

async function getGiftBoxPrice() {
    const GIFT_BOX_VARIANT_ID = '45756434972921';
    
    try {
        // First, check if gift box is already in cart - use that price
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const giftBoxInCart = cart.items.find(item => 
            item.variant_id.toString() === GIFT_BOX_VARIANT_ID
        );
        
        if (giftBoxInCart) {
            // Use the actual cart price (already formatted by Shopify Markets)
            return formatPrice(giftBoxInCart.price, cart.currency || 'AUD');
        }
        
        // If not in cart, try getting market-specific price via variant endpoint
        const variantResponse = await fetch(`/products/gift-box/variants/${GIFT_BOX_VARIANT_ID}.js`);
        const variant = await variantResponse.json();
        
        if (variant && variant.price) {
            const currency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) 
                ? Shopify.currency.active 
                : 'AUD';
            return formatPrice(variant.price, currency);
        }
        
        // Final fallback - try product endpoint
        const productResponse = await fetch('/products/gift-box.js');
        const product = await productResponse.json();
        
        if (product && product.price) {
            const currency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) 
                ? Shopify.currency.active 
                : 'AUD';
            return formatPrice(product.price, currency);
        }
        
    } catch (error) {
        console.error('Error fetching gift box price:', error);
    }
    
    // Ultimate fallback
    return '$18';
}

function formatPrice(priceInCents, currency) {
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(priceInCents / 100);
}

function handleGiftBoxChange(event) {
    const isChecked = event.target.checked;
    const GIFT_BOX_VARIANT_ID = '45756434972921';
    
    if (isChecked) {
        addGiftBoxToCart(GIFT_BOX_VARIANT_ID);
    } else {
        removeGiftBoxFromCart(GIFT_BOX_VARIANT_ID);
    }
}

function addGiftBoxToCart(variantId) {
    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', 1);
    
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        console.log('Gift box added to cart');
        // Refresh page to show updated cart
        setTimeout(() => {
            window.location.reload();
        }, 300);
    })
    .catch(error => {
        console.error('Error adding gift box:', error);
        // Revert checkbox state on error
        const checkbox = document.getElementById('giftBoxCheckbox');
        if (checkbox) checkbox.checked = false;
    });
}

function removeGiftBoxFromCart(variantId) {
    // Use cart/change.js to remove specific variant
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 0);
    
    fetch('/cart/change.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        console.log('Gift box removed from cart');
        // Refresh page to show updated cart
        setTimeout(() => {
            window.location.reload();
        }, 300);
    })
    .catch(error => {
        console.error('Error removing gift box:', error);
        // Revert checkbox state on error
        const checkbox = document.getElementById('giftBoxCheckbox');
        if (checkbox) checkbox.checked = true;
    });
}

function checkInitialGiftBoxState() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const hasGiftBox = cart.items.some(item => 
                item.variant_id.toString() === '45756434972921'
            );
            
            const checkbox = document.getElementById('giftBoxCheckbox');
            if (checkbox) {
                checkbox.checked = hasGiftBox;
            }
        })
        .catch(error => {
            console.error('Error checking cart state:', error);
        });
}

function monitorCartChanges() {
    // Monitor for cart changes every 2 seconds
    setInterval(() => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const hasGiftBox = cart.items.some(item => 
                    item.variant_id.toString() === '45756434972921'
                );
                
                const checkbox = document.getElementById('giftBoxCheckbox');
                if (checkbox && checkbox.checked !== hasGiftBox) {
                    checkbox.checked = hasGiftBox;
                }
            })
            .catch(error => {
                console.error('Error monitoring cart:', error);
            });
    }, 2000);
}